import {
    GET_PAYMENT_STATUS,
    GET_PAYMENT_CATEGORIES,
    GET_FILE_STATUS,
    // GET_PAYMENT_FEES
    GET_PAYMENT_BENEFICIARY,
    FILE_PARSE_STATUS_DONE,
    FILE_PARSE_STATUS,
    GET_PARSE_RECORD,
    GET_SAVED_PAYMENT,
    GET_PAYMENT_DETAILS,
    GET_PUBLIC_KEY,
    UPDATE_PAYMENT_STATUS
} from "../types/paymentType";

const initialState = {
    paymentCategories: [],
    paymentStatus: [],
    fileParseStatus: {},
    parseRecords: [],
    savedPayments: [],
    fileStatus: [],
    paymentDetails: [],
    paymentBeneficiaries: [],
    publicKey: "",
    totalElements: 0,
    size: 25,
    number: 0
};

const paymentReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_PAYMENT_CATEGORIES:
            return {
                ...state,
                paymentCategories: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        case GET_FILE_STATUS:
            return {
                ...state,
                fileStatus: payload.content
            };
        case GET_PAYMENT_BENEFICIARY:
            return {
                ...state,
                paymentBeneficiaries: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        case GET_PAYMENT_DETAILS:
            return {
                ...state,
                paymentDetails: payload.content
            };
        case GET_PAYMENT_STATUS:
            return {
                ...state,
                paymentStatus: payload.content
            };
        case GET_SAVED_PAYMENT:
            return {
                ...state,
                savedPayments: payload.content
            };
        case GET_PARSE_RECORD:
            return {
                ...state,
                parseRecords: payload.content,
                totalElements: payload.totalElements,
                size: payload.size,
                number: payload.number
            };
        case FILE_PARSE_STATUS:
            let fileStatusArray = state.fileStatus;
            let newState = fileStatusArray.map((obj) =>
                parseInt(obj?.batchId) === parseInt(payload?.data?.paymentReference)
                    ? {
                          ...obj,
                          summary: null,
                          processedCount: payload?.data?.processedCount
                          // status:payload?.data?.status
                      }
                    : obj
            );
            return {
                ...state,
                fileStatus: [...newState]
            };
        case FILE_PARSE_STATUS_DONE:
            let currentFileStatus = state?.fileStatus;
            let itemIdx = currentFileStatus?.findIndex(
                (item) => item?.batchId === payload?.data?.paymentReference
            );
            currentFileStatus[itemIdx].status = payload?.data?.status;
            currentFileStatus[itemIdx].processedCount = payload?.data?.processedCount;
            return {
                ...state,
                fileStatus: [...currentFileStatus]
            };
        case GET_PUBLIC_KEY:
            return {
                ...state,
                publicKey: payload
            };
        case UPDATE_PAYMENT_STATUS:
            let updatingPaymentStatus = state?.paymentStatus;
            let itemIndex = updatingPaymentStatus?.findIndex(
                (item) => item.paymentReference === payload?.data?.paymentReference
            );
            updatingPaymentStatus[itemIndex].status = payload?.data?.status;
            return {
                ...state,
                paymentStatus: [...updatingPaymentStatus]
            };
        default:
            return state;
    }
};

export default paymentReducer;
